// Module
var code = "<script>let $panelRow</script> <div class=\"molecule-panel-edit-row\" ng-if=\"!$panelRow.isAvailable\"> <molecule-panel-callout type=\"warning\" display-title=\"false\"> <span>{{ $panelRow.calloutMessage }}</span> </molecule-panel-callout> </div> ";
// Exports
module.exports = code;